module.exports = __webpack_public_path__ + "img/commercial_06_condition.79bacc96.svg";